import React from 'react'
import Divider from '@mui/material/Divider'
import { StyledEngineProvider } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import classes from './Header.module.css'

const Header = () => {
  let count = useSelector((state) => state.counter.value)

  return (
    <StyledEngineProvider injectFirst>
      <header className={classes.header}>
        <div className={classes.innerContainer}>
          <h1 className={classes.title}>INVADERS GENERATOR</h1>
          <h2 className={classes.subTitle}>
            currently we are surrounded by{' '}
            <span className={classes.invaderNumber}>{count}</span> invaders
          </h2>
          <Divider className={classes.divider} />
        </div>
      </header>
    </StyledEngineProvider>
  )
}

export default Header
